import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Registers every *_controller.js in this folder by file name:
// plan_picker_controller.js -> data-controller="plan-picker"
const controllers = import.meta.glob("./*_controller.js", { eager: true })

for (const [path, module] of Object.entries(controllers)) {
  const name = path.match(/\.\/(.+)_controller\.js$/)[1].replaceAll("_", "-")
  application.register(name, module.default)
}
